import React, { FC } from 'react';
import TwDialog from '../TwDialog/TwDialog';
import { TwButton, TwButtonType } from '../TwButtons/TwButtons';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactComponent as WarningSign } from '../../assets/warning-sign.svg';

interface TwDeleteTagModalProps {
  tagToDelete: string | null;
  openDeleteConfirmation: boolean;
  closeDeleteModal: () => void;
  onDelete: () => void;
}

const TwDeleteTagModal: FC<TwDeleteTagModalProps> = ({
  tagToDelete,
  openDeleteConfirmation,
  closeDeleteModal,
  onDelete
}): JSX.Element => {
  return (
    <TwDialog
      size="xs"
      title="Delete tag?"
      open={openDeleteConfirmation}
      onClickClose={closeDeleteModal}
      actions={[
        <TwButton key="1" type={TwButtonType.secondary} label="Cancel" action={closeDeleteModal} />,
        <TwButton key="2" type={TwButtonType.negative} label="Delete" action={onDelete} />
      ]}
    >
      <Box>
        <Box sx={{ textAlign: 'center' }}>
          <WarningSign />
        </Box>
        <Typography fontSize={14} color={'#6B7280'}>
          Are you sure you want to delete <b>{`#${tagToDelete}`}</b> tag? This action cannot be
          undone
        </Typography>
      </Box>
    </TwDialog>
  );
};

export default TwDeleteTagModal;
